import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const TransferReviewDetailsQuery = gql`
  query TransferReviewDetails($input: TransferReviewDetailsInput!) {
    transferReviewDetails(input: $input) {
      __typename
      ... on TransferReviewDetails {
        rail
        title
        disclaimer
        transferQuoteToken
        transferDetails {
          from {
            ownership
            institutionName
            transferTypeDescriptor
          }
          to {
            ownership
            institutionName
            transferTypeDescriptor
          }
          transferType
          transferSpeedAnalyticsValue
          feeRate
          feeAmount {
            ...money
          }
        }
        sections {
          id
          title
          items {
            primaryText
            secondaryText
            primaryNumberOfLines
            boldPrimaryCopy
            lineFormat
            isDisabled
            showsChevron
            accessibilityLabel
            trailingAccessory {
              __typename
              ... on VxlListItemTrailingTextAccessory {
                primaryCopy
                secondaryCopy
                boldPrimaryCopy
                primaryNumberOfLines
              }
            }
          }
        }
      }
      ... on TransferReviewDetailsError {
        code
        errorTitle: title
        message
        errorCode
      }
    }
  }
  ${money}
`;

export default TransferReviewDetailsQuery;
